import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {GeneratedInvoiceResponse, GenerateInvoiceRequest, InvoiceGeneratorPreparation} from "../interface/invoice-generator";


@Injectable({
  providedIn: 'root'
})
export class InvoiceGeneratorService {
  constructor(private httpClient: HttpClient) {}

  public prepare(contractUuid: string, issueDate: string): Observable<InvoiceGeneratorPreparation> {
    const params = new HttpParams().set('issueDate', issueDate);

    return this.httpClient.get<InvoiceGeneratorPreparation>(
      `/rest/crm/invoice-generator/prepare/${contractUuid}`,
      {params},
    ).pipe(take(1));
  }

  public generate(formData: GenerateInvoiceRequest): Observable<GeneratedInvoiceResponse> {
    return this.httpClient.post<GeneratedInvoiceResponse>(
      '/rest/crm/invoice-generator',
      formData,
    ).pipe(take(1));
  }
}
